var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.scormUid)?_c('iframe',{key:_vm.scormUid,staticStyle:{"height":"80vh","width":"100%"},attrs:{"id":"scormFrameContentPreview","frameBorder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }